<div
    *ngIf="serviceTerm"
    class="row"
>
    <div class="col-md-12">
        <div class="terms-and-conditions panel">
            <div [innerHTML]="serviceTerm"></div>
        </div>
        <p>
            I acknowledge that by checking “I consent” below, I am expressly consenting to the collection and processing of my Biometric Data
            and that such consent is effective until and unless I affirmatively withdraw that consent in writing to
            <a href="mailto:privacy@paragontesting.ca">privacy@paragontesting.ca</a>.
            Please note that consent is required to complete test registration.

        </p>
        <div class="my-4">
            <strong>Do You Consent to the collection, processing, use and storage of your Biometric Data?</strong>
            <div class="my-2">
                <div class="consent-checkbox">
                    <label>
                        <input
                            name="biometricConsent"
                            type="checkbox"
                            [(ngModel)]="isBiometricConsent"
                        />
                        <span>I consent</span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-md-12">
        <div class="form-group">
            <button
                type="button"
                (click)="goNext()"
                class="btn btn-primary"
                [disabled]=!isBiometricConsent
            >Next</button>
        </div>
    </div>
</div>
